import Vue from 'vue';
import Router from 'vue-router';

import RouterComponent from './components/RouterComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   component: () => import(/* webpackChunkName: "index" */ './views/Index.vue'),
    // },
    {
      path: '/signup',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signup" */ './views/Signup.vue'),
    },
    {
      path: '/setup',
      component: () => import(/* webpackChunkName: "setup" */ './views/setup/Setup.vue'),
      redirect: '/setup/basic',
      children: [
        {
          path: 'basic',
          component: () => import(/* webpackChunkName: "basic" */ './views/setup/Basic.vue'),
        },
        {
          path: 'product',
          component: () => import(/* webpackChunkName: "product" */ './views/setup/Product.vue'),
        },
        {
          path: 'finance',
          component: () => import(/* webpackChunkName: "finance" */ './views/setup/Finance.vue'),
        },
        {
          path: 'complete',
          component: () => import(/* webpackChunkName: "complete" */ './views/setup/Complete.vue'),
        },
        {
          path: 'restore',
          redirect: '/setup/basic',
        },
      ],
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/recover-password',
      component: () => import(/* webpackChunkName: "recover-password" */ './views/PasswordRecovery.vue'),
    },
    {
      path: '/reset-password',
      component: () => import(/* webpackChunkName: "reset-password" */ './views/PasswordReset.vue'),
    },
    {
      path: '/google-callback',
      component: () => import(/* webpackChunkName: "signup" */ './views/GoogleCallBack.vue'),
    },
    {
      path: '',
      component: () => import(/* webpackChunkName: "start" */ './views/main/Start.vue'),
      redirect: '/main',
      children: [
        {
          path: '/main',
          component: () => import(/* webpackChunkName: "main" */ './views/main/Main.vue'),
          children: [
            {
              path: 'dashboard',
              component: () => import(/* webpackChunkName: "main-dashboard" */ './views/main/dashboard/Dashboard.vue'),
            },
            {
              path: 'dashboard/debt',
              component: () => import(/* webpackChunkName: "main-debt" */ './views/main/dashboard/Debt.vue'),
            },
            {
              path: 'dashboard/equity',
              component: () => import(/* webpackChunkName: "main-debt" */ './views/main/dashboard/Equity.vue'),
            },
            {
              path: 'user',
              component: RouterComponent,
              redirect: 'account-info',
              children: [
                {
                  path: 'account-info',
                  component: () => import(/* webpackChunkName: "main-user-profile" */ './views/main/user/AccountInfo.vue'),
                },
              ]
            },
            {
              path: 'report',
              component: RouterComponent,
              // redirect: 'report/view',
              children: [
                {
                  path: 'source',
                  component: () => import(
                    /* webpackChunkName: "main-report-source" */ './views/main/report/Source.vue'),
                },
              ],
            },
            {
              path: 'admin',
              component: () => import(/* webpackChunkName: "main-admin" */ './views/main/admin/Admin.vue'),
              redirect: 'admin/reports',
              children: [
                {
                  path: 'users',
                  component: () => import(
                    /* webpackChunkName: "main-admin-users" */ './views/main/admin/Users.vue'),
                },
                {
                  path: 'reports',
                  component: () => import(
                    /* webpackChunkName: "main-admin-reports" */ './views/main/admin/Reports.vue'),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/*', redirect: '/login',
    },
  ],
});
